import Cta from "./cta";

// pretitle - title - description - cta component
function Ptdc({
  pretitle,
  title,
  description,
  ctaText,
  ctaLink,
  size = "default",
  importantTitle = false,
  className = "",
  ctaClassname,
}) {
  const ptdcClasses = `
        ptdc ${className} ${size}
    `.trim();

  return (
    <div className={ptdcClasses}>
      {pretitle ? <h4 className="pretitle">{pretitle}</h4> : null}
      {title ? (
        importantTitle ? (
          <h1 className="title">{title}</h1>
        ) : (
          <div className="title">{title}</div>
        )
      ) : null}
      {description ? <p className="description">{description}</p> : null}
      {(ctaText && ctaLink) ? (
        <Cta
          text={ctaText}
          link={ctaLink}
          className={"cta-standard " + ctaClassname}
        />
      ) : null}
    </div>
  );
}

export default Ptdc;
